import { formatDate } from '@/utils/constants';
import { safelyParseDate } from '@/utils/date';

export const USER_ROLE_OPTIONS = [
	'Financial Adviser',
	'Adviser Admin',
	'Claims',
	'Debtors',
	'Compliance',
];

export const USERS_FUSE_OPTIONS = {
	keys: ['name', 'primaryEmail', 'phone', 'role'],
	threshold: 0.2,
};

export const formatDateTime = (value) => {
	const date = safelyParseDate(value);
	if (!date) return '-';
	try {
		return formatDate(date, true);
	} catch {
		return '-';
	}
};

export const getDateSortValue = (value) => safelyParseDate(value)?.getTime() ?? 0;

export const getUserRoleLabel = (user = {}) => {
	if (typeof user?.role === 'string' && user.role.trim()) {
		return user.role.trim();
	}
	// if (user?.isFolioAdmin) return 'Folio Admin';
	// if (user?.principleUser) return 'Principal';
	// if (user?.brokerAdmin) return 'Broker Admin';
	// if (user?.complianceManager) return 'Compliance Manager';
	return '-';
};

export const getUserBrokerGroupIds = (user = {}) =>
	Array.from(
		new Set(
			[user?.brokerGroupId, ...(user?.brokerGroupArray ?? [])].filter(Boolean).map(String),
		),
	);

export const getPrimaryEmail = (user = {}) => {
	const proxy = user?.proxyAddresses ?? [];
	const primary =
		proxy.find((addr) => typeof addr === 'string' && addr.startsWith('SMTP:')) ?? '';
	const fromProxy = primary.replace(/^SMTP:/i, '').trim();
	return fromProxy || user?.email || user?.displayEmail || '';
};

export const mapBrokerageUserRow = (user = {}) => ({
	id: user.id,
	name: user.name ?? '-',
	hubspotId: user.hubspotId,
	email: user.email,
	primaryEmail: getPrimaryEmail(user) || '-',
	phone: user.phoneNumber ?? '-',
	role: getUserRoleLabel(user),
	brokerGroupIds: getUserBrokerGroupIds(user),
	lastUpdated: user.lastUpdated ?? null,
	lastUpdatedBy: user.lastUpdatedBy ?? null,
});
